import React from "react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Collapse } from "reactstrap";
import "./style.scss";

function AccordionComponent({
  title,
  children,
  isOpen,
  toggle,
  value,
  style = {},
}) {
  const { t } = useTranslation();

  const handleToggle = useCallback(() => {
    toggle(value);
  }, [toggle, value]);
  return (
    <div className="accordion w-100">
      <div
        className={`header ${isOpen && "active"}`}
        onClick={handleToggle}
        style={style}
      >
        <h5>{t(title)}</h5>
        <i className="bx bx-chevron-right" />
      </div>
      <Collapse isOpen={isOpen}>{children}</Collapse>
    </div>
  );
}

export default AccordionComponent;
